export default __webpack_public_path__ + "assets/park_car.4292f24f.png";